import React, { useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import '../css/patientsForm.css'
import { submitEnrollment } from "../api/enrollApi";
import { useNavigate } from "react-router-dom";
import { COUNTRIES_ENROLLMENT_URL } from "../config/lrApproval";

// Variables de entorno para reCAPTCHA
const URL_API_VERIFY_CAPTCHA = `${process.env.REACT_APP_BMS_PSP_ENDPOINT}/api/v1/verify-recaptcha`;
const ENABLE_CAPTCHA = process.env.REACT_APP_ENABLE_CAPTCHA === "true";

const BMSParticipantForm = () => {
  const [pais, setPais] = useState("");
  const [nombre, setNombre] = useState("");
  const [prefijoTelefonico, setPrefijoTelefonico] = useState(null);
  const [prefijoTelefonico2, setPrefijoTelefonico2] = useState(null);
  const [prefijoTelefonicoList, setPrefijoTelefonicoList] = useState([]);
  const [telefono, setTelefono] = useState("");
  const [telefono2, setTelefono2] = useState(null);
  const [terminos, setTerminos] = useState(false);
  const [loading, setLoading] = useState(null);
  //const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate()
  const [countries, setCountries] = useState([]);
  const [doctor, setDoctor] = useState(null);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setError(null);

    // Verificar reCAPTCHA si está habilitado
    if (ENABLE_CAPTCHA) {
      console.log(URL_API_VERIFY_CAPTCHA);
      if (!executeRecaptcha) {
        setError('reCAPTCHA no está listo. Por favor, recargue la página.');
        return;
      }

      try {
        // Obtener token fresco al momento del submit
        const captchaToken = await executeRecaptcha('patient_form_submit');

        const response = await fetch(URL_API_VERIFY_CAPTCHA, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ captcha_value: captchaToken }),
        });

        if (!response.ok) {
          setError('Error al verificar captcha. Intente de nuevo más tarde.');
          return;
        }

        const dataCaptcha = await response.json();
        if (!dataCaptcha.success) {
          setError('Captcha Inválido');
          return;
        }
      } catch {
        setError('Error de conexión al verificar captcha');
        return;
      }
    }

    try {
      setLoading(true);

      const body = {
        name: nombre,
        country_id: parseInt(pais),
        prefix1_id: parseInt(prefijoTelefonico),
        tel1: telefono,
        prefix2_id: parseInt(prefijoTelefonico2),
        tel2: telefono2,
        terms: terminos,
        doctor: doctor,
      };

      const result = await submitEnrollment(
        process.env.REACT_APP_BMS_PSP_ENDPOINT,
        body,
      );

      setLoading(false);

      if (result.ok) {
        navigate("/qrThankYou");
        return;
      }

      setError(result.message);
    } catch (e) {
      console.error(e);
      setLoading(false);
      setError("Ocurrió un error. Por favor, intente de nuevo.");
    }
  }

  const resetForm = (e) => {
    e.preventDefault();
    setLoading(null);
    setError(null);
  }

  const getCountries = async () => {
    try {
      const response = await fetch(COUNTRIES_ENROLLMENT_URL);
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    getCountries()
  }, []);

  const onCountryChange = (e) => {
    setPais(e.target.value);
    if (e.target.value === "") {
      setPrefijoTelefonicoList([]);
      setPrefijoTelefonico(null);
      return;
    }
    const filteredCountry = countries.find(countryObject => parseInt(e.target.value) === countryObject.id);
    setPrefijoTelefonicoList(filteredCountry.prefix);
    setPrefijoTelefonico(filteredCountry.prefix[0].id);
  }

  return (
    <div className="patient-form-section">
      {loading === null && <>
        <h4 className="patient-form-header">
          Registre aquí sus datos, para ser contactado.
        </h4>
        <form onSubmit={handleSubmitForm}>
          <div className="patient-form-item">
            <label htmlFor="pais" className="patient-form-label">
              País (Obligatorio)
            </label>
            <br />
            <select
              name="pais"
              id="pais"
              className={pais === "" ? 'patient-form-input select-placeholder' : 'patient-form-input'}
              onChange={onCountryChange}
              required={true}
              value={pais}
            >
              <option value="">Seleccionar país</option>
              {
                countries.length === 0 && <option value="" disabled={true}>Cargando...</option>
              }
              {
                countries.length > 0 &&
                countries.map((obj, index) =>
                  <option className='select-item' key={index} value={obj.id}>{obj.country}</option>
                )
              }
            </select>
          </div>
          <div className="patient-form-item">
            <label htmlFor="patient-name" className="patient-form-label">
              Nombre completo (Obligatorio)
            </label>
            <input
              type="text"
              id="patient-name"
              className="patient-form-input"
              onChange={(e) => (setNombre(e.target.value))}
              required={true}
              placeholder="Ej: Juan Pérez"
            />
          </div>
          <div className="patient-form-item">
            <label htmlFor="patient-telefono" className="patient-form-label">
              Teléfono 1 (Obligatorio)
            </label>
            <div className="form-flex">
              <select
                name="patient-tel-code"
                id="patient-tel-code"
                className={!prefijoTelefonico ? "patient-form-code select-placeholder" : "patient-form-code"}
                onChange={(e) => (setPrefijoTelefonico(e.target.value))}
                required={true}
                value={prefijoTelefonico}
              >
                {prefijoTelefonicoList.length === 0 && <option value="">Seleccionar prefijo</option>}
                {prefijoTelefonicoList.map((item, index) => {
                  return (
                    <option value={item.id} key={index} className='select-item'>
                      ({item.tel_prefix})
                    </option>
                  );
                })}

              </select>
              <input
                type="number"
                id="patient-telefono"
                className="patient-form-tel"
                onChange={(e) => (setTelefono(e.target.value))}
                required={true}
                placeholder="Ej: 099 123 456"
              />
            </div>
          </div>
          <div className="patient-form-item">
            <label htmlFor="patient-telefono" className="patient-form-label">
              Teléfono 2 (Opcional)
            </label>
            <div className="form-flex">
              <select
                name="patient-tel-code"
                id="patient-tel-code"
                className={!prefijoTelefonico2 ? "patient-form-code select-placeholder" : "patient-form-code"}
                onChange={(e) => (setPrefijoTelefonico2(e.target.value))}
                value={prefijoTelefonico2}
              >
                <option value="">Seleccionar prefijo</option>
                {prefijoTelefonicoList.map((item, index) => {
                  return (
                    <option value={item.id} key={index} className='select-item'>
                      ({item.tel_prefix})
                    </option>
                  );
                })}

              </select>
              <input
                type="number"
                id="patient-telefono"
                className="patient-form-tel"
                onChange={(e) => (setTelefono2(e.target.value))}
                placeholder="Ej: 099 321 654"
              />
            </div>
          </div>
          <div className="patient-form-item">
            <label htmlFor="patient-name" className="patient-form-label">
              Médico tratante (Opcional)
            </label>
            <input
              type="text"
              id="patient-name"
              className="patient-form-input"
              onChange={(e) => (setDoctor(e.target.value))}
              required={false}
              placeholder="Ej: María Rodriguez"
            />
          </div>
          <div className="form-flex">
            <div className="checkbox-form">
              <input type="checkbox" id="myCheck" onChange={(e) => (setTerminos(e.target.checked))} required={true} />
            </div>
            <div className="checkbox-info">
              Declaro que toda la información proporcionada es verdadera y que he
              leído el <strong>consentimiento informado</strong>.
            </div>
          </div>
          <div className="patient-form-item">
            <input
              className="patient-form-submit"
              type="submit"
              value="Contácteme"
            />
          </div>
        </form>
      </>}
      {loading === true &&
        <h3 className="thanks-message">
          Guardando...
        </h3>
      }
      { /*!loading && status===201 && 
      <>
        <h3 className="thanks-message">
          Gracias por registrarse
        </h3>
        <form onSubmit={resetForm}>
          <div className="patient-form-item">
            <input
              className="patient-form-submit"
              type="submit"
              value="Volver al formulario"
            />
          </div>
        </form>
      </>
    */}
      {!loading && error &&
        <>
          <div className="thanks-message enroll-error-message" role="alert">
            {error}
          </div>
          <form onSubmit={resetForm}>
            <div className="patient-form-item">
              <input
                className="patient-form-submit"
                type="submit"
                value="Intentar de nuevo"
              />
            </div>
          </form>
        </>
      }
    </div>
  );
};

export default BMSParticipantForm;
